import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f0c6467"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"block-bg-circles\" data-v-7f0c6467><svg viewBox=\"0 0 1154 1154\" data-v-7f0c6467><g fill=\"#FFF\" fill-rule=\"evenodd\" data-v-7f0c6467><circle cx=\"577\" cy=\"577\" opacity=\".055\" r=\"577\" data-v-7f0c6467></circle><circle cx=\"577.5\" cy=\"576.5\" opacity=\".045\" r=\"405.5\" data-v-7f0c6467></circle></g></svg></div>", 1)
const _hoisted_2 = { class: "container" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["textContent"]
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "lead pr-2" }
const _hoisted_7 = ["href", "target", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LinkButton = _resolveComponent("LinkButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["block", _ctx.blockBackgroundClass(_ctx.vm.backgroundColor)])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["row", _ctx.contentAlignmentClass])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["mb-2", [_ctx.textAlignmentClass(_ctx.vm.alignment), _ctx.colSizeClass]])
        }, [
          (_ctx.vm.title)
            ? (_openBlock(), _createElementBlock("h2", {
                key: 0,
                class: "",
                innerHTML: _ctx.vm.title
              }, null, 8, _hoisted_3))
            : _createCommentVNode("", true),
          (_ctx.vm.subtitle)
            ? (_openBlock(), _createElementBlock("h3", {
                key: 1,
                class: "display-5 mb-0",
                textContent: _toDisplayString(_ctx.vm.subtitle)
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["d-flex flex-wrap mb-2 mt-auto col-auto gap-2", [
						_ctx.contentAlignmentClass,
						!_ctx.vm.ctaRight && _ctx.vm.alignment === _ctx.horizontalAlignment.Center ? 'mx-auto' : '',
					]])
        }, [
          (_ctx.vm.ctaLeft)
            ? (_openBlock(), _createBlock(_component_LinkButton, {
                key: 0,
                class: _normalizeClass({
							'p-button-lg': _ctx.vm.size === _ctx.size.large,
							[_ctx.ctaButtonClass(_ctx.vm.ctaLeftStyle)]: _ctx.ctaButtonClass(_ctx.vm.ctaLeftStyle),
							'p-button-text p-button-raised p-button-arrow':
								!_ctx.ctaButtonClass(_ctx.vm.ctaLeftStyle) && _ctx.vm.ctaRight,
							'p-button-success p-button-raised p-button-arrow':
								!_ctx.ctaButtonClass(_ctx.vm.ctaLeftStyle) && !_ctx.vm.ctaRight,
						}),
                label: _ctx.vm.ctaLeft.text,
                target: _ctx.vm.ctaLeft.target,
                title: _ctx.vm.ctaLeft.title,
                url: _ctx.vm.ctaLeft.url
              }, null, 8, ["class", "label", "target", "title", "url"]))
            : _createCommentVNode("", true),
          (_ctx.vm.ctaRight)
            ? (_openBlock(), _createBlock(_component_LinkButton, {
                key: 1,
                class: _normalizeClass({
							'p-button-lg': _ctx.vm.size === _ctx.size.large,
							[_ctx.ctaButtonClass(_ctx.vm.ctaRightStyle)]: _ctx.ctaButtonClass(_ctx.vm.ctaRightStyle),
							'p-button-success p-button-raised p-button-arrow': !_ctx.ctaButtonClass(_ctx.vm.ctaRightStyle),
						}),
                label: _ctx.vm.ctaRight.text,
                target: _ctx.vm.ctaRight.target,
                title: _ctx.vm.ctaRight.title,
                url: _ctx.vm.ctaRight.url
              }, null, 8, ["class", "label", "target", "title", "url"]))
            : _createCommentVNode("", true)
        ], 2)
      ], 2),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.vm.bottomText || _ctx.vm.ctaBottom)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["col-12 d-flex mt-2", _ctx.contentAlignmentClass])
            }, [
              _createElementVNode("p", _hoisted_6, [
                _createTextVNode(_toDisplayString(_ctx.vm.bottomText) + " ", 1),
                (_ctx.vm.ctaBottom)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: _normalizeClass({
								'text-primary':
									_ctx.vm.backgroundColor === _ctx.blockBackgroundColor.Grey ||
									_ctx.vm.backgroundColor === _ctx.blockBackgroundColor.Pink ||
									_ctx.vm.backgroundColor === _ctx.blockBackgroundColor.White,
								'text-white':
									_ctx.vm.backgroundColor === _ctx.blockBackgroundColor.Purple ||
									_ctx.vm.backgroundColor === _ctx.blockBackgroundColor.Green,
							}),
                      href: _ctx.vm.ctaBottom.url,
                      target: _ctx.vm.ctaBottom.target,
                      title: _ctx.vm.ctaBottom.title
                    }, _toDisplayString(_ctx.vm.ctaBottom.text), 11, _hoisted_7))
                  : _createCommentVNode("", true)
              ])
            ], 2))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}